import { SkeletonElement } from '../../../common/components';
import { css } from '@bts-web/utils-style-engine';
import { AppLogoWithIslamicProp } from '../Reusable/AppLogo/AppLogoWithIslamicProp.use-client';

const MobileHeaderSkeleton = () => {
  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingX: 'medium',
        minHeight: '64px',
      })}
      data-testid="mobile-header-skeleton"
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: 'medium',
        })}
      >
        <AppLogoWithIslamicProp size={34} textLogoSize={160} />
      </div>

      <div className={css({ display: 'flex', gap: 'small' })}>
        <SkeletonElement width="20px" height="20px" />
        <SkeletonElement width="20px" height="20px" />
      </div>
    </div>
  );
};

export { MobileHeaderSkeleton };
